document.addEventListener("DOMContentLoaded", function () {
    const videoContainers = document.querySelectorAll(".compare-element__video");
    const mediaVideos = document.querySelectorAll(".compare-element__video video");

    mediaVideos.forEach(video => {
        video.addEventListener("pause", () => {
            video.removeAttribute("controls");
        });

        // To avoid errors in page speed test
        const imageInVideo = video.querySelector("img");
        if (imageInVideo) {
            imageInVideo.alt = "Video poster"
            imageInVideo.loading = "lazy"
        }
    });

    videoContainers.forEach((button, index) => {
        button.addEventListener("click", () => {
            if (mediaVideos[index].paused) {
                stopAllVideos();
                playVideo(mediaVideos[index]);
            } else {
                mediaVideos[index].pause();
                mediaVideos[index].removeAttribute("controls");
            }
        });
    });

    function stopAllVideos() {
        mediaVideos.forEach(video => {
            video.pause();
            video.removeAttribute("controls");
        });
    }

    function playVideo(video) {
        video?.play().then(() => video.setAttribute("controls", "true"));
    }
});
